define('SageDotCom/DataLayer/Events/Forms/freeTrialFormSubmitSuccess',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function FreeTrialFormSubmitSuccess() {
        EventBase.call(this); // inherit eventBase
        this.name = 'trial_submit'; // overwrite name
    }

    FreeTrialFormSubmitSuccess.prototype = Object.create(EventBase.prototype);

    FreeTrialFormSubmitSuccess.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope) {
        var eventData = {
            "event_name": this.getName(), //event name
            "event_non-int": "0", //non interaction point
            "event_category": "ecommerce", //top line category
            "event_action": "trial_submit" //specific action
        }

        if (scope) {
            var productName = $(scope).attr("data-product-name");
            var productSku = $(scope).attr("data-sku");
            var productFamily = $(scope).attr("data-product-family");
            var productPrice = $(scope).attr("data-product-price");

            eventData = $.extend(eventData, {
                'event_label': productName,
                'event_name_level_1': this.getId(scope),
                'event_name_level_2': productFamily,
                'event_name_level_3': productPrice,
                'event_name_level_4': productSku
            });
        }

        return eventData;
    }

    return new FreeTrialFormSubmitSuccess();
});
